// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from "./Components/NavBar/NavBar";
import Top from "./Components/Top/Top";
import Middle from "./Components/Middle/Middle";
import Allocation from "./Components/Allocation/Allocation";
import Terms from "./Components/Terms/Terms"; // 如果你已经创建了这个组件

function App() {
  return (
    <Router>
      <div className="App">
        {/* 这里放一个全局的 Navbar */}
        <Navbar />

        {/* 这里使用 Routes+Route 来配置页面 */}
        <Routes>
          {/* 首页（或者你想显示其他内容的页面） */}
          <Route 
            path="/" 
            element={
              <>
                <Top />
                <Middle />
                <Allocation />
              </>
            } 
          />

          {/* Terms 页面（只放 Terms 也可以，或者想要再次引入 Navbar 也行） */}
          <Route 
            path="/terms" 
            element={
              <>
                {/* 如果你要在这个页面也显示 Navbar，可以直接写在这里 */}
                <Terms />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;